import { reduceAction } from '../helpers';

import types from './types';

const collectImpression = (state, { trackerType, data }) => {
    let update = {};

    if (trackerType === 'product') update = { product: [...state.product, data] };
    else if (trackerType === 'promotion') update = { promotion: [...state.promotion, data] };
    else if (trackerType === 'story') update = { story: [...state.story, data] };

    return { ...state, ...update };
};
const clearImpressions = (state, collectionKey) =>
    state[collectionKey] ? { ...state, [collectionKey]: [] } : state;

const impressionsInitialState = { product: [], promotion: [], story: [] };

const impressionsReducer = (state = impressionsInitialState, { type, payload }) => {
    switch (type) {
        case types.COLLECT_IMPRESSION:
            return collectImpression(state, payload);
        case types.CLEAR_IMPRESSIONS:
            return clearImpressions(state, payload);
        case types.COLLECT_STORY_IMPRESSION:
            return collectImpression(state, payload);
        default:
            return state;
    }
};

const checkoutReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.SET_CURRENT_STEP:
            return { ...state, step: payload, loginOption: false };

        case types.SET_CHECKOUT_OPTION:
            return reduceAction(state, 'checkoutOption', payload);

        case types.SET_ADDITIONAL_STEP:
            return reduceAction(state, 'additionalStep', payload);

        case types.SET_LOGIN_OPTION:
            return reduceAction(state, 'loginOption', payload);

        default:
            return state;
    }
};

const pageReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.SET_CURRENT_PAGE:
            return { ...state, current: payload.page };
        case types.SET_LOCATION:
            return { ...state, location: payload.location };
        default:
            return state;
    }
};

const productListReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.SET_CURRENT_PRODUCT_LIST:
            return { ...state, current: payload.productList };
        default:
            return state;
    }
};

const pageInfoReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.SET_PAGE_LOAD_INFO:
            return { ...state, ...payload };
        default:
            return state;
    }
};

const pdpReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.SET_ADD_REVIEW_START_TIME:
            return { ...state, startTime: payload };
        default:
            return state;
    }
};

const gtmInitialState = {
    types: [],
};

const gtmReducer = (state = gtmInitialState, { type, payload }) => {
    /* TECH DEBT: see if saga TAKE EVERY put a lock for counter resilience */
    switch (type) {
        case types.INCREMENT_CURRENT_WRAPPER_COUNTER:
            return { ...state, types: [...state.types, payload] };
        case types.SET_WRAPPER:
            return { ...state, types: [...state.types, payload] };
        case types.RESET_WRAPPERS_BY_TYPE:
            return {
                ...state,
                types: [...state.types].filter(e => e.type !== payload.type),
            };
        default:
            return state;
    }
};

const orderConfirmationReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.PROCEED_PAGELOAD:
            return { ...state, proceedPageLoad: payload };
        default:
            return state;
    }
};

const minicartReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.SET_MINICART_POPOVER_STATUS:
            return { ...state, ...payload };
        default:
            return state;
    }
};

const pageLoadReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case types.SET_PAGELOAD:
            return payload;
        default:
            return state;
    }
};

const analyticsInitialState = {
    impressions: impressionsInitialState,
    checkout: { step: null, checkoutOption: '', additionalStep: false, loginOption: false },
    page: { current: null },
    productList: { current: null },
    gtmCounter: gtmInitialState,
    orderConfirmation: { proceedPageLoad: false },
    minicartReducer: { opened: false },
    isPageLoad: false,
    pdp: { startTime: 0 },
};

const analyticsReducer = (state = analyticsInitialState, action) => ({
    impressions: impressionsReducer(state.impressions, action),
    checkout: checkoutReducer(state.checkout, action),
    page: pageReducer(state.page, action),
    productList: productListReducer(state.productList, action),
    pageInfo: pageInfoReducer(state.pageInfo, action),
    gtmCounter: gtmReducer(state.gtmCounter, action),
    orderConfirmation: orderConfirmationReducer(state.orderConfirmation, action),
    minicartReducer: minicartReducer(state.minicart, action),
    isPageLoad: pageLoadReducer(state.isPageLoad, action),
    pdp: pdpReducer(state.pdp, action),
});

export default analyticsReducer;
